import { Progress, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

interface ActionUploadProgressProps {
  busy: boolean;
  uploadPercent?: number | null;
}

/**
 * Bytes reaching 100% only means the browser finished sending the file to
 * DMS - the launch HTTP response (and the RTU accepting the action) is a
 * separate, unbounded wait. Showing the same "Uploading file to DMS" label
 * frozen at 100% reads as stuck; this switches to a distinct "starting
 * action" state once the transfer itself is done.
 */
export const ActionUploadProgress = ({ busy, uploadPercent }: ActionUploadProgressProps) => {
  const { t } = useTranslation();
  if (!busy || uploadPercent === null || uploadPercent === undefined) return null;

  if (uploadPercent < 100) {
    return (
      <div className="dms-action-modal__browser-upload">
        <span>{t('actionsModal.transfer.browserUpload', { defaultValue: 'Uploading file to DMS' })}</span>
        <Progress percent={uploadPercent} size="small" />
      </div>
    );
  }

  return (
    <div className="dms-action-modal__browser-upload dms-action-modal__browser-upload--starting">
      <Spin size="small" />
      <span>{t('actionsModal.transfer.startingAction', { defaultValue: 'File uploaded. Starting action…' })}</span>
    </div>
  );
};

export default ActionUploadProgress;
